// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SocialLi: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M12.9 36.7h5V20.8h-5zM31.5 20.6c-2.9 0-4.6 1.6-5 2.7v-2.5h-5.6c.1 1.3 0 15.9 0 15.9h5.6v-8.6c0-.5 0-1 .1-1.3.4-1 1.2-2 2.7-2 1.9 0 2.8 1.5 2.8 3.6v8.2h5.6v-8.9c.1-4.8-2.7-7.1-6.2-7.1M15.3 13.2c-1.8 0-3 1.2-3 2.8 0 1.5 1.2 2.8 3 2.8 1.9 0 3-1.2 3-2.8-.1-1.6-1.2-2.8-3-2.8"/></svg>;
};

export default React.memo(SocialLi);
